import React, { Component } from 'react';
import {
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap";


import OperationsOrders from "../components/Operations/Orders";
import OperationsRecurrentList from "../components/Operations/Recurrents";
import OperationsExport from "../components/Operations/Export";
import OperationsOrderDetails from "../components/Operations/Order";
import OperationsFleet from "../components/Operations/Fleet";
import Helpers from "../Utils/Helpers";
import EnterpriseAddresses from "../components/Enterprise/Addresses";


class Operations extends Component {
    constructor(props){
        super(props);

        this.toggleTab = this.toggleTab.bind(this);

        this.keys_links = {
            recurrente: "recurrent",
			en_attente: "orders_waiting",
            en_cour: "orders_coming",
            passees: "orders_done",
            flotte: "fleet",
            adresses: "addr",
			export: 'export'
        };

        let default_key = "orders_done";
        if(this.props.match.params.subkey && this.keys_links[this.props.match.params.subkey])
            default_key = this.keys_links[this.props.match.params.subkey];

        this.state = {
            openedTab: default_key
        };
    }

    toggleTab(key){
        this.setState({openedTab: key}, () => {
            Helpers.scrollOnClick(key);
        });
    }

    goTo = key => {
        if(this.keys_links[key]){
            Helpers.goTo("/operations/" + key);
            this.setState({openedTab: this.keys_links[key]}, () => {
                Helpers.scrollOnClick(this.keys_links[key]);
            });
        }
    };

    render() {
        let order_details = false;
        if(this.props.match.params.orderId)
            order_details = <OperationsOrderDetails orderId={this.props.match.params.orderId} />;

        return (
            <div className="no-padding">
                <Nav tabs className="header-tabs" id="container">
					<NavItem>
						<NavLink
							className={ this.state.openedTab === "recurrent" ? "active" : "" }
							onClick={() => { this.goTo("recurrente"); }}
							id="recurrent"
						>
							Commandes r&eacute;currentes
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink
							className={ this.state.openedTab === "orders_waiting" ? "active" : "" }
							onClick={() => { this.goTo("en_attente"); }}
							id="orders_waiting"
						>
							Commandes en attente
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink
							className={ this.state.openedTab === "orders_coming" ? "active" : "" }
							onClick={() => { this.goTo("en_cour"); }}
							id="orders_coming"
						>
							Commandes en cours
						</NavLink>
					</NavItem>
                    <NavItem>
                        <NavLink
                            className={ this.state.openedTab === "orders_done" ? "active" : "" }
                            onClick={() => { this.goTo("passees"); }}
                            id="orders_done"
                        >
                            Commandes pass&eacute;es
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={ this.state.openedTab === "fleet" ? "active" : "" }
                            onClick={() => { this.goTo("flotte"); }}
                            id="fleet"
                        >
                            Flotte
                        </NavLink>
                    </NavItem>
                    <NavItem id="addr">
                        <NavLink
                            className={ this.state.openedTab === "addr" ? "active" : "" }
                            onClick={() => { this.goTo("adresses"); }}
                            id="addr"
                        >
                            Adresses de livraison
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={ this.state.openedTab === "export" ? "active" : "" }
                            onClick={() => { this.goTo("export"); }}
                            id="export"
                        >
                            Exports
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent className="header-tabs pad-tab-content" activeTab={this.state.openedTab}>
                    <TabPane tabId="orders_waiting">
                        {
                            order_details ?
                                order_details
                                :
                                <OperationsOrders orderStatus="waiting" />
                        }
                    </TabPane>
                    <TabPane tabId="orders_coming">
                        {
                            order_details ?
                                order_details
                            :
                                <OperationsOrders orderStatus="coming" />
                        }
                    </TabPane>
                    <TabPane tabId="orders_done">
                        {
                            order_details ?
                                order_details
                            :
                                <OperationsOrders orderStatus="done" />
                        }
                    </TabPane>
                    <TabPane tabId="fleet">
                        <OperationsFleet />
                    </TabPane>
                    <TabPane tabId="addr">
                        <EnterpriseAddresses />
                    </TabPane>
                    <TabPane tabId="export">
                        <OperationsExport />
                    </TabPane>
                    <TabPane tabId="recurrent">
                        <OperationsRecurrentList />
                    </TabPane>
                </TabContent>
            </div>
        )
    }

}

export default Operations;



// WEBPACK FOOTER //
// ./src/views/Operations.js